export default __webpack_public_path__ + "static/media/DisabledClearIcon.0d186aab.svg";